import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { addItemDriverFactory } from './AddItem.driver';
import { AddItem } from '.';

describe('AddItem', () => {
  const createDriver = createRendererWithUniDriver(addItemDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<AddItem />);
    expect(await driver.exists()).toBe(true);
  });

  it('should add the correct text', async () => {
    const { driver } = createDriver(<AddItem>Add Item</AddItem>);
    expect(await driver.getText()).toBe('Add Item');
  });

  it('should call onClick function', async () => {
    const onClick = jest.fn();
    const { driver } = createDriver(
      <AddItem onClick={onClick}>AddItem</AddItem>,
    );
    await driver.click();
    expect(onClick).toHaveBeenCalled();
  });
});
